const { log } = console
const FileSaver = require('file-saver')
const JSZip = require('jszip')
const { findSpriteByName } = require('./utils/find-target.js')
const { generateSaveData } = require('./utils/save-load-scene.js')

function getProjectDataFromZip (zip) {
  const promises = []
  Object.values(zip.files).forEach(file => {
    if (file.name.split('.')[1] === 'json') {
      promises.push(file.async('string'))
    }
    if (file.name.split('.')[1] === 'sb3') {
      promises.push(file.async('arraybuffer'))
    }
  })
  return Promise.all(promises)
}

module.exports = function store (state, emitter) {
  emitter.on('export-scene', () => {
    log('export-scene')
    emitter.emit('pause')
    state.wasGamePlaying = false
    const exportMetadata = generateSaveData(state)

    state.glitchApplications.forEach(g => {
      emitter.emit('remove-glitch', g.id)
    })

    state.addedParts.forEach(p => {
      emitter.emit('delete-sprite', findSpriteByName(state.vm, p.spriteName).id)
    })

    state.vm.saveProjectSb3().then(sb3 => {
      sb3.arrayBuffer().then(result => {
        state.sceneData = result
        state.sceneMetadata = exportMetadata
        emitter.emit('load-scene')
      })
      const zip = new JSZip()
      const fileToSave = new Blob(
        [
          JSON.stringify(
            state.sceneMetadata
          )
        ],
        {type: 'text/plain;charset=utf-8'}
      )
      zip.file(`${state.sceneMetadata.projectId}.sb3`, sb3)
      zip.file(`${state.sceneMetadata.projectId}.json`, fileToSave)
      zip.generateAsync({type: 'blob'}).then(blob => {
        FileSaver.saveAs(blob, `${state.sceneMetadata.projectId}.gb1`)
      })
    })
    emitter.emit('deselect-all')
  })

  emitter.on('open-import-dialog', () => {
    log('open-import-dialog')
    const input = document.createElement('input')
    input.type = 'file'
    input.onchange = () => {
      input.files[0].arrayBuffer().then(arrayBuffer => {
        const zip = new JSZip()
        zip.loadAsync(arrayBuffer).then(contents => {
          getProjectDataFromZip(contents).then(results => {
            let projectMetadata, projectData
            results.forEach(data => {
              if (typeof (data) === 'string') {
                projectMetadata = JSON.parse(data)
              } else if (typeof (data) === 'object') {
                projectData = data
              }
            })
            if (projectData && projectMetadata) {
              state.sceneData = projectData
              state.sceneMetadata = projectMetadata
              emitter.emit('load-scene')
            } else {
              emitter.emit('render')
            }
          })
        })
      })
    }
    input.click()
  })
}
